import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=32073ce8&scoped=true"
import script from "./Warranty.vue?vue&type=script&lang=js"
export * from "./Warranty.vue?vue&type=script&lang=js"
import style0 from "./Warranty.vue?vue&type=style&index=0&id=32073ce8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32073ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Generac.Application.MobileLink\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32073ce8')) {
      api.createRecord('32073ce8', component.options)
    } else {
      api.reload('32073ce8', component.options)
    }
    module.hot.accept("./Warranty.vue?vue&type=template&id=32073ce8&scoped=true", function () {
      api.rerender('32073ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApparatusDetails/Warranty.vue"
export default component.exports